import { render, staticRenderFns } from "./SendReceiptAdviceForm.vue?vue&type=template&id=596e7966&"
import script from "./SendReceiptAdviceForm.vue?vue&type=script&lang=js&"
export * from "./SendReceiptAdviceForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports